@if (contractDuration$ | async; as contractDuration) {
  @if (contractDuration?.length) {
    @for (item of contractDuration; track item) {
      <udex-radio-button
        name="contractDuration"
        [text]="item.displayText"
        [checked]="formControl.value === item.value"
        (change)="onRadioChange(item.value)">
      </udex-radio-button>
    }
  }
}
